// Переход в CRM продаж под тем же логином.
//
// Билет забираем запросом с заголовком — при обычном переходе браузер его не
// пошлёт, и ручка не узнает, кто идёт. Дальше отправляем билет POST-формой, а
// не в адресе: строка запроса пишется в журнал nginx целиком, у нас и у них, и
// живой билет лежал бы на диске, пока человек не дошёл.
//
// Если что угодно не сложилось — секрета нет, сеть, отказ, — уходим обычной
// ссылкой. Человек введёт логин руками, как делал вчера. Мёртвая кнопка хуже
// лишнего ввода пароля.

const CRM = 'https://al-crm.pl';

const apiBase = () => {
  if (typeof window !== 'undefined') {
    const o = window.location.origin;
    if (!o.includes('localhost') && !o.includes('127.0.0.1')) return o;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Путь внутри CRM: только относительный и только с одного «/». Проверяют и у
// них, но чинить открытый редирект надо на обеих сторонах, а не на одной.
const chistyyPut = (next) => {
  const p = String(next || '/');
  return /^\/(?!\/)[A-Za-z0-9\-._~/%]*$/.test(p) ? p : '/';
};

export async function perejtiVCrm(next = '/') {
  const put = chistyyPut(next);
  const zapasnoy = () => { window.location.href = CRM + put; };
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return zapasnoy();
    const r = await fetch(`${apiBase()}/api/sso/ticket-to-crm`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) return zapasnoy();
    const d = await r.json();
    if (!d?.ticket || !d?.url) return zapasnoy();

    const f = document.createElement('form');
    f.method = 'POST';
    f.action = d.url;
    Object.entries({ ticket: d.ticket, next: put }).forEach(([k, v]) => {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = k;
      i.value = v;
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  } catch (e) {
    zapasnoy();
  }
}
